import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";

// Custom styles
const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: 33.1,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
};


const KRAKPIMapping = () => {
  const [data, setData] = useState([
    {
      id: 1, code: "369", name: "MAHESH",
      kra: "Responsibility and Ownership (Examination & Audit)",
      kpi: "Active participation and Planning", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 2, code: "369", name: "MAHESH",
      kra: "Responsibility and Ownership (Examination & Audit)",
      kpi: "Negative feedback from parents", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 3, code: "369", name: "MAHESH",
      kra: "Responsibility and Ownership (Examination & Audit)",
      kpi: "Process based learning", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 4, code: "369", name: "MAHESH",
      kra: "Responsibility and Ownership (Examination & Audit)",
      kpi: "Rating Creation", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 5, code: "019", name: "KARTHI R",
      kra: "Personnel Development (Event Allocation)",
      kpi: "Ensure and Communicate in English", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 6, code: "019", name: "KARTHI R",
      kra: "Academic - Review",
      kpi: "Detail Lesson Plan - Planning and Submission", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 7, code: "019", name: "KARTHI R",
      kra: "Training Implementation",
      kpi: "5 learning session for all department", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 8, code: "019", name: "KARTHI R",
      kra: "Rating",
      kpi: "Rating Creation", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 9, code: "006", name: "REVATHY",
      kra: "Personnel Development (Special Initiatives & Event Allocation)",
      kpi: "Activity plan and execution", kpiWeightage: "10.00", isActive: true
    },
    {
      id: 10, code: "006", name: "REVATHY",
      kra: "Personnel Development (Special Initiatives & Event Allocation)",
      kpi: "5 learning session for all department", kpiWeightage: "10.00", isActive: true
    }
  ]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const employeeOptions = [
    { value: "002-VIGNESH", label: "002-VIGNESH" },
    { value: "369-MAHESH", label: "369-MAHESH" },
    { value: "019-KARTHI R", label: "019-KARTHI R" },
    { value: "006-REVATHY", label: "006-REVATHY" },
  ];

  const kraOptions = [
    { value: "Responsibility and Ownership (Examination & Audit)", label: "Responsibility and Ownership (Examination & Audit)" },
    { value: "Personnel Development (Event Allocation)", label: "Personnel Development (Event Allocation)" },
    { value: "Academic - Review", label: "Academic - Review" },
    { value: "Training Implementation", label: "Training Implementation" },
    { value: "Rating", label: "Rating" },
    { value: "Personnel Development (Special Initiatives & Event Allocation)", label: "Personnel Development (Special Initiatives & Event Allocation)" },
  ];

  const kpiOptions = [
    { value: "Active participation and Planning", label: "Active participation and Planning" },
    { value: "Negative feedback from parents", label: "Negative feedback from parents" },
    { value: "Process based learning", label: "Process based learning" },
    { value: "Rating Creation", label: "Rating Creation" },
    { value: "Ensure and Communicate in English", label: "Ensure and Communicate in English" },
    { value: "Detail Lesson Plan - Planning and Submission", label: "Detail Lesson Plan - Planning and Submission" },
    { value: "5 learning session for all department", label: "5 learning session for all department" },
    { value: "Activity plan and execution", label: "Activity plan and execution" },
  ];

  const formik = useFormik({
    initialValues: {
      employee: "",
      kra: "",
      kpi: "",
      kpiWeightage: "",
    },
    validationSchema: Yup.object({
      employee: Yup.string().required("Employee is Required"),
      kra: Yup.string().required("KRA is Required"),
      kpi: Yup.string().required("KPI is Required"),
      kpiWeightage: Yup.string().required("Weightage is Required"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (isEdit) {
        setData(prevData =>
          prevData.map(item =>
            item.id === editId ? {
              ...item,
              code: values.employee.split('-')[0],
              name: values.employee.split('-')[1],
              kra: values.kra,
              kpi: values.kpi,
              kpiWeightage: values.kpiWeightage
            } : item
          )
        );
        setIsEdit(false);
        setEditId(null);
      } else {
        const newRow = {
          id: data.length + 1,
          code: values.employee.split('-')[0],
          name: values.employee.split('-')[1],
          kra: values.kra,
          kpi: values.kpi,
          kpiWeightage: values.kpiWeightage,
          isActive: true,
        };
        setData(prev => [...prev, newRow]);
      }
      resetForm();
    },
  });

  const handleEdit = (row) => {
    formik.setValues({
      employee: `${row.code}-${row.name}`,
      kra: row.kra,
      kpi: row.kpi,
      kpiWeightage: row.kpiWeightage,
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const columns = [
    {
      Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Code", accessor: "code" },
    { Header: "Name", accessor: "name" },
    { Header: "KRA", accessor: "kra" },
    { Header: "KPI", accessor: "kpi" },
    { Header: "KPI-W", accessor: "kpiWeightage" },
    {
      Header: "Edit",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: (cellProps) => (
        <Link to="#" className="text-success" onClick={() => handleEdit(cellProps.row.original)}>
          <i className="bx bxs-edit font-size-18" id={`edit-tooltip-${cellProps.row.id}`} />
          <UncontrolledTooltip placement="top" target={`edit-tooltip-${cellProps.row.id}`}>
            Edit
          </UncontrolledTooltip>
        </Link>
      ),
    },
    {
      Header: "Status",
      className: "status-col",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const isActive = cellProps.row.original.isActive;
        return (
          <Link to="#" style={{ color: isActive ? "green" : "red" }}>
            <i
              className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
              id={`status-tooltip-${cellProps.row.id}`}
            />
            <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
              {isActive ? "Active" : "Inactive"}
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="KRA KPI Mapping" breadcrumbItem="KRA KPI Mapping" />

        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="">
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>Employee <span className="text-danger">*</span></Label>
                    <Select
                      options={employeeOptions}
                      onChange={(selected) => formik.setFieldValue("employee", selected.value)}
                      onBlur={() => formik.setFieldTouched("employee", true)}
                      value={employeeOptions.find(opt => opt.value === formik.values.employee)}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.employee && formik.errors.employee && (
                      <div className="text-danger">{formik.errors.employee}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>KRA <span className="text-danger">*</span></Label>
                    <Select
                      options={kraOptions}
                      onChange={(selected) => formik.setFieldValue("kra", selected.value)}
                      onBlur={() => formik.setFieldTouched("kra", true)}
                      value={kraOptions.find(opt => opt.value === formik.values.kra)}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.kra && formik.errors.kra && (
                      <div className="text-danger">{formik.errors.kra}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>KPI <span className="text-danger">*</span></Label>
                    <Select
                      options={kpiOptions}
                      onChange={(selected) => formik.setFieldValue("kpi", selected.value)}
                      onBlur={() => formik.setFieldTouched("kpi", true)}
                      value={kpiOptions.find(opt => opt.value === formik.values.kpi)}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.kpi && formik.errors.kpi && (
                      <div className="text-danger">{formik.errors.kpi}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <Label>KPI Weightage <span className="text-danger">*</span></Label>
                    <Input
                      type="number"
                      name="kpiWeightage"
                      value={formik.values.kpiWeightage}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.touched.kpiWeightage && formik.errors.kpiWeightage ? "is-invalid" : ""}
                    />
                    {formik.touched.kpiWeightage && formik.errors.kpiWeightage && (
                      <div className="text-danger">{formik.errors.kpiWeightage}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md="12" className="text-end">
                  <Button type="subit" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button" className="btn button-cancel"  onClick={formik.handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer columns={columns} data={data} isGlobalFilter={true} customPageSize={10} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default KRAKPIMapping;